// TSS vite/03 §"Query keys convention" + vite/04 §"Endpoint paths".
// Fincas del cliente (public/farms). Vive en common/ porque TRES features lo
// consumen —fincas (CRUD), receptoras (FarmSelect) y donadoras-externas
// (FarmSelect)— y así evita el cross-import entre features (vite/01).
//
// Keys: tuplas entity-first, scope estrechándose a la derecha. `all` cubre
// lista y detalle (['farms', …]) → invalidar farmKeys.all refresca ambos.
export const farmKeys = {
    all:    ['farms'],
    list:   (filters) => ['farms', filters],
    detail: (id) => ['farms', id],
};

// Paths RELATIVOS al canal público (sin /api/v1 — lo pone el baseURL del api
// client). Un rename en el backend toca solo este archivo.
export const farmPaths = {
    list:   () => 'public/farms',
    detail: (id) => `public/farms/${id}`,
};
